import React from 'react'

import "./basicSetupDetails.scss"

import PageRedirectButton from 'components/CommunityOnboardingComp/SetupDetailsUtilities/PageRedirectButton';
import ProductTourVideo from 'components/CommunityOnboardingComp/SetupDetailsUtilities/ProductTourVideo';

export interface IBasicSetupDetails {
    groupData: any
    subdomain: string
    compSelected: any
    description: string
}

const BasicSetupDetails: React.FC<IBasicSetupDetails> = ({ groupData, subdomain, description }) => {

    const homepageUrl: string = "settings/homepage"
    const [isdisplayVideo, setDisplayVideo] = React.useState(false);

    return (
        <>
            {
                isdisplayVideo && (
                    <ProductTourVideo
                        isdisplayVideo={isdisplayVideo}
                        setDisplayVideo={setDisplayVideo}
                        videoId={1045160584}
                        sectionTitle="Watch how to configure your Community Homepage"

                    />
                )
            }
            <ul className='setup-details-items'>
                <span className='setup-details-items-span'>{description}</span>
                <li className='setup-detail'>
                    <div className="onboarding-message-content-container">
                        <div
                            className="onboarding-message-content"
                            onClick={() => setDisplayVideo(true)}
                        >
                            <img
                                className="onboarding-message-content-img"
                                src='https://static.group.app/assets/getting-started/Community%20Home%20Page%20-%202.png'
                                alt="GroupApp Demo Walkthrough"
                            />
                        </div>
                    </div>
                    <div className='setup-item-btn'>
                        <PageRedirectButton
                            url={homepageUrl}
                            subdomain={subdomain}
                            group={groupData}
                        />

                    </div>
                </li>
            </ul>

        </>
    )
}

export default BasicSetupDetails
